import { render, staticRenderFns } from "./AboutMembersMore.vue?vue&type=template&id=ed34c040&"
import script from "./AboutMembersMore.vue?vue&type=script&lang=js&"
export * from "./AboutMembersMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports